export const API_BASE_URL = "/api/efrikort/client";
export const API_BASE_PKIX_URL = "/api/pkix";
export const API_BASE_WS_URL = "/api/ws/metadata";
export const API_BASE_AUTHENTICATION_URL = "/api/authentication";
export const API_USER_URL = "/api/user";
export const COMFACT_CONTRACT = API_BASE_URL + "/comfact/contract/";
export const COMFACT = API_BASE_URL + "/comfact/";

export const SSN = "ssn";
export const NATURE = "nature";
export const EMBEDDED = "embedded";

export const headingSize = "h4";

export const INVALID_DATE = "Invalid Date";

export const TECHNICAL = "TECHNICAL";
